<template>
	<div>
		<v-navigation-drawer
      v-model="drawer"
      app
			:permanent = drawer
			clipped
			v-if="logonUser"
    >
			<v-list dense>
        <template v-for="(item, i) in items">
          <v-row
            v-if="item.heading"
            :key="i"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            
          </v-row>
          <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-2"
          />
          <v-list-item
            v-else
            :key="i"
            link
						:to="{name: item.to}"
						exact
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

			<v-app-bar
     	dark 
			color="admin_accent"
      app 
			flat
			clipped-left
    >

			<v-app-bar-nav-icon color="white" v-if="logonUser" @click.stop="drawer = !drawer" />

       <v-toolbar-title>Menú QR - Restaurante Tapas</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- <v-btn outlined color="white" class="mr-3" v-if="!logonUser" to="/login">
        <v-icon class="mr-2">mdi-account-key </v-icon> Login
      </v-btn> -->

		<!-- 	<v-btn outlined color="white" class="mr-3" to="/admin/dashboard">
        <v-icon class="mr-2">mdi-view-dashboard</v-icon> Dashboard 
      </v-btn> -->

			<v-btn icon class="mr-3"  v-if="logonUser" @click="logOff">
        <v-icon class="mr-2">mdi-exit-to-app</v-icon> 
      </v-btn>
    </v-app-bar>


			<!-- <v-toolbar dark color="admin_accent">
				<v-toolbar-title>Menu QR - Administración</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-btn icon class="">
					<v-icon>mdi-lock-open-variant</v-icon>
				</v-btn>
				<v-btn icon class="">
					<v-icon>mdi-lock</v-icon>
				</v-btn>
			</v-toolbar> -->





	</div>
</template>

<script>
	var firebase = require("firebase/app")
	import { mapActions, mapGetters } from "vuex";
	import navigationMixin from '@/helpers/navigation';
	export default {
		name: 'AdminToolbar',
		mounted(){
		},
		data: () => ({
			drawer:null,
			permanente: true,
			items: [
        { icon: 'mdi-view-dashboard', text: 'Inicio', to: 'AdminBusiness' },
				{ divider: true },
        //{ icon: 'mdi-account-group', text: 'Clientes', to: 'AdminCustomer' },
				{ divider: true },
				{ icon: 'mdi-garage-variant', text: 'Negocios', to: 'AdminBusiness' },
				// { divider: true },
				// { icon: 'mdi-folder-table', text: 'Productos', to: 'AdminProduct' },
				{ divider: true },
				// { icon: 'mdi-exit-to-app', text: 'Salir', to: 'close' },
				// { divider: true },
			],

		}),
		methods: {
			...mapActions(['logOff']),
		},
		computed: {
			...mapGetters(['logonUser'])
		},
		
	}
</script>

<style lang="scss" scoped>

</style>